import { createSelector } from 'reselect';
import { RootState } from '../index';
import { StockEmployeesState } from '../slices/stockEmployeesSlice';

const selectStockEmployeesState = (state: RootState): StockEmployeesState => state.stockEmployeesState;

export const selectStockEmployees = createSelector([selectStockEmployeesState], (s) => s.employees);

export const selectTotalRowStockEmployees = createSelector([selectStockEmployeesState], (s) => s.totalRow);

export const selectIsStockEmployeesLoading = createSelector([selectStockEmployeesState], (s) => s.isEmployeesLoading);

export const selectSelectedStockEmployeeToUpdate = createSelector([selectStockEmployeesState], (s) => s.selectedEmployeeToUpdate);

export const selectIsGetStockEmployeeByNameLoading = createSelector([selectStockEmployeesState], (s) => s.isGetEmployeeByNameLoading);

export const selectIsUpdateStockEmployeeLoading = createSelector([selectStockEmployeesState], (s) => s.isUpdateEmployeeLoading);

export const selectIsAddStockEmployeeLoading = createSelector([selectStockEmployeesState], (s) => s.isAddEmployeeLoading);
